import packageJson from "../../package.json"
export const VERSION = packageJson.version;
export const CONFIG= window.CONFIG;
export const tipoPasarela= "EJ2";
export const servidor= CONFIG.servidor;
export const servidorImagenes= CONFIG.servidorImagenes;
export const sessionCaducidadMinutos= CONFIG.sessionCaducidadMinutos;
export const terminalCodigo= CONFIG.terminalCodigo;
export const nombreCliente= CONFIG.nombreCliente;

export const intervaloReloj= CONFIG.intervaloReloj;
export const intervaloComprobacionServidor = CONFIG.intervaloComprobacionServidor;
export const tiempoEsperaInformacionMarcaje = CONFIG.tiempoEsperaInformacionMarcaje;

export const nombrePaquete= "com.ej2sistemas.ej2bizsuite.";
export const servicioRestful= "restful/"
export const titulo= "EJ2 Presencia remota";

export const encabezado=  CONFIG.encabezado;


/*
En Package.json:
"homepage": "http://localhost/timebiz.webterm",
 */